import { FC, ReactNode, useEffect, useState } from 'react'

import { Alert, Box, Text } from '@factorialco/deprecated-design-system'
import { Icon } from '@factorialco/factorial-one-react'
import { LockLocked } from '@factorialco/factorial-one-react/icons/app'

import TextArea from '../../../core/components/TextArea'
import TextField from '../../../core/components/TextField'
import i18n from '../../../core/lib/i18n'
import { Element } from '../../lib/Element'
import { Form } from '../../lib/Form'
import QuestionContentDropdown from '../dropdowns/QuestionContentDropdown'
import SectionContentDropdown from '../dropdowns/SectionContentDropdown'

interface Props {
  children?: ReactNode
  element: Element
  form: Form
  onChange: (element: Element) => void
  onDelete: (element: Element) => void
}

const ElementEditor: FC<Props> = ({ children, element, form, onChange, onDelete }) => {
  const [label, setLabel] = useState<string>(element.label)
  const [description, setDescription] = useState<string>(element.description)
  useEffect(() => {
    setLabel(element.label)
    setDescription(element.description)
  }, [element])
  const section = element.sectionId ? form.getElement(element.sectionId) : false
  const position = section
    ? `${section.position + 1}.${element.position + 1}`
    : element.position + 1
  const title =
    element.getType() === 'section'
      ? i18n.t('forms.editor.section_position_title', { position: position })
      : i18n.t('forms.editor.question_position_title', { position: position })
  const dropDown =
    element.getType() === 'section' ? (
      <SectionContentDropdown onDelete={() => onDelete(element)} />
    ) : (
      <QuestionContentDropdown
        element={element}
        onChange={onChange}
        onDelete={() => onDelete(element)}
      />
    )

  return (
    <Box gap="s8">
      <Box justifyContent="spaceBetween" flexDirection="row" padding="s6">
        <Box flexDirection="row" gap="s4" alignItems="center">
          <Icon icon={element.getIcon()} />
          <Text size="200" weight="medium">
            {title}
          </Text>
          {element.mandatory && (
            <Text size="200" weight="medium" color="accentBackgroundSolid">
              {'*'}
            </Text>
          )}
        </Box>
        <Box flexDirection="row" gap="s4">
          {element.isLocked() && <Icon icon={LockLocked} />}
          {dropDown}
        </Box>
      </Box>
      <Box
        borderRadius={{ all: 'abs016' }}
        border={{ all: { color: 'grey400', width: 's1', style: 'solid' } }}
        padding="s24"
        gap="s8"
      >
        <TextField
          placeholder={i18n.t('forms.editor.question_label_placeholder')}
          mandatory
          value={label}
          onChange={setLabel}
          onBlur={() => {
            if (label == element.label) return
            element.label = label
            onChange(element)
          }}
          // error={errors.label}
        />
        <TextArea
          placeholder={i18n.t('forms.editor.description_placeholder')} // TODO: Translate
          value={description}
          onChange={setDescription}
          onBlur={() => {
            if (description == element.description) return
            element.description = description
            onChange(element)
          }}
        />
        {element.getParam<boolean>('optional_comment') && (
          <Alert color="info">{i18n.t('forms.editor.optional_comment')}</Alert>
        )}
        {children}
      </Box>
    </Box>
  )
}
export default ElementEditor
